<div class="prescription-selector" *ngIf="!isScanComplete">
  <label><b>Select Prescription:</b></label>
  <select id="prescriptionJump" class="form-select d-inline w-auto" (change)="jumpToPrescription($event)">
    <option *ngFor="let id of prescriptionIds" [value]="id">
      {{ groupedMedications[id].patientName }}
    </option>
  </select>
</div>
<div class="safescan-container" *ngIf="prescriptionIds.length > 0 && !isScanComplete">
  <h6 class="header" align="center">SafeScan BATCH - Scanning All Patients</h6>

  <div class="instruction-bar">
    <div class="progress-info" style="margin-top: -35px;">
      Scanning <strong>{{ currentPrescriptionIndex + 1 }} of {{ prescriptionIds.length }}</strong>
    </div>
    <p class="instruction-text">
      Please scan medications for each patient prescription.
    </p>
  </div>

  <div class="all-patients-container">
    <div class="patient-section">
      <div class="patient-header">
        <div class="left-header">
          <span class="patient-name">{{ currentPatientName }}</span>
          <span class="medication-count">
            {{ currentMedicines.length }} Medications
          </span>
        </div>
        <div class="navigation-buttons d-flex justify-content-between align-items-center" style="margin-top: 1rem;">
          <button class="btn btn-secondary previous" *ngIf="!isFirstPrescription &&!isScanComplete"
            (click)="previousPatient()">Previous</button>
          <div style="flex-grow: 1;"></div>

          <button class="btn btn-primary next" *ngIf="!isLastPrescription && isStartBtnClicked"
            (click)="nextPatient()">Next</button>
          <button class="btn btn-success next" *ngIf="isLastPrescription &&!isScanComplete && isStartBtnClicked"
            (click)="finishScan()">Finish</button>
        </div>

      </div>

      <div class="medications-grid">
        <div *ngFor="let medicine of currentMedicines" class="medication-card-wrapper"
          [ngClass]="scanStatuses[currentPrescriptionId][medicine.medicationId] === 'SCANNED' ? 'active-class' : 'medication-card'">

          <!-- <button class="cancel-btn" title="Cancel" (click)="onCancel(medicine)" [ngClass]="{
          'visible-btn': scanStatuses[currentPrescriptionId][medicine.medicationId] === 'SCANNED'
          }">
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button> -->

          <!-- <div
            [ngClass]="scanStatuses[currentPrescriptionId][medicine.medicationId] === 'SCANNED' ? 'scan-status-green' : 'scan-status'">
            {{ scanStatuses[currentPrescriptionId][medicine.medicationId] }}
          </div> -->
          <div *ngIf="scanStatuses[currentPrescriptionId][medicine.medicationId] === 'SCANNED'" class="scan-success-title">
            SCAN SUCCESS
          </div>

          <div *ngIf="scanStatuses[currentPrescriptionId][medicine.medicationId] !== 'SCANNED'" class="scan-status">
            NOT SCANNED
          </div>

          <!-- <div
            [ngClass]="scanStatuses[currentPrescriptionId][medicine.medicationId] === 'SCANNED' ? 'active-class-name' : 'medication-name'">
            {{ medicine.medicationId }}
          </div> -->
          <div class="medication-id" *ngIf="showMedicationId">
            {{ medicine.medicationId }}
          </div>
          <div
            [ngClass]="scanStatuses[currentPrescriptionId][medicine.medicationId] === 'SCANNED' ? 'active-class-name' : 'medication-name'">
            {{ medicine.medicationName }}
          </div>
          <div
            [ngClass]="scanStatuses[currentPrescriptionId][medicine.medicationId] === 'SCANNED' ? 'active-class-dosage' : 'medication-dosage'">
            {{ medicine.dosage }}
          </div>
          <button
            *ngIf="scanStatuses[currentPrescriptionId][medicine.medicationId] === 'SCANNED'"
            class="remove-btn"
            (click)="onCancel(medicine)">
            ✕ Remove
          </button>
        </div>
      </div>

    </div>

    <!-- <div class="scanned-patients">
      <div class="scanned-patient-name" *ngFor="let scannedId of prescriptionIds.slice(0, currentPrescriptionIndex)"
      (click)="toggleMedicineModal(scannedId)">
        <hr />
        <strong>{{ groupedMedications[scannedId].patientName }}</strong> –
        {{ getScannedCount(scannedId) }} of
        {{ groupedMedications[scannedId].medicines.length }} medicines scanned
      </div>
    </div> -->
    <div class="scanned-patients">
  <div *ngFor="let scannedId of prescriptionIds.slice(0, currentPrescriptionIndex)">
    <div class="scanned-patient-name" (click)="toggleCollapse(scannedId)">
      <hr />
      <strong>{{ groupedMedications[scannedId]?.patientName }}</strong> –
      {{ getScannedCount(scannedId) }} of
      {{ groupedMedications[scannedId]?.medicines.length }} medicines scanned
    </div>

    <!-- Collapsible Medicine Details -->
    <div *ngIf="expandedPrescriptionId === scannedId" class="medicines-collapse">
      <div *ngFor="let med of groupedMedications[scannedId]?.medicines" class="medicine-row">
        <div><strong>{{ med.medicationName }}</strong></div>
        <div>{{ med.dosage }}</div>
        <div [ngClass]="{
          'status-pending': scanStatuses[scannedId]?.[med.medicationId] === 'PENDING',
          'status-scanned': scanStatuses[scannedId]?.[med.medicationId] === 'SCANNED'
        }">
          {{ scanStatuses[scannedId]?.[med.medicationId] || 'UNKNOWN' }}
        </div>
      </div>
    </div>
  </div>
</div>

  </div>
</div>
<div *ngIf="showPrinterSelectionModal" class="printer-modal">
  <h3>Select a printer</h3>
  <select [(ngModel)]="selectedPrinter">
    <option *ngFor="let printer of availablePrinters" [value]="printer">
      {{ printer }}
    </option>
  </select>
  <button (click)="printPreference()" class="btn btn-primary">Select</button>
</div>

<div *ngIf="isScanComplete" class="batch-summary mt-4">
  <h5 class="text-center mb-3">📋 Batch Summary</h5>
  <table class="summary-table">
    <thead>
      <tr>
        <th>Patient Name</th>
        <th>Remaining</th>
        <th>Remark</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let id of prescriptionIds">
        <td>{{ groupedMedications[id]?.patientName }}</td>
        <td>{{ groupedMedications[id]?.medicines?.length-getScannedCount(id) }}</td>
        <td *ngIf="getScannedCount(id) < groupedMedications[id]?.medicines?.length">
          Some medications not scanned</td>
        <!-- <ng-template #message>No remark.</ng-template> -->
      </tr>
    </tbody>
  </table>
</div>
<!-- print section -->
<div id="print-medicine">
  <div id="medicine-list" class="med-container">
    <div class="medicine" id="medicine">
      <div class="text-section">
        <p class="child-warning">Keep out of sight & reach of children</p>
        <h4 class="med-name">{{ printMedication?.medicationName }} {{ printMedication?.medicineDosage }}</h4>
        <p class="dose-instruction">{{ printMedication?.instruction }}</p>
      </div>

      <!-- <div class="barcode-section">
        <ngx-barcode6 [bc-value]="printMedication?.medicationId ?? ''" [bc-display-value]="false" [bc-width]="1"
          [bc-height]="20">
        </ngx-barcode6>
      </div> -->
    </div>
  </div>
</div>
<!-- packlabel -->
<div id="print-pack-label">
  <div id="medicine-list" class="med-container">
    <div class="medicine">
      <div class="text-section">
        <p class="child-warning">Keep out of sight & reach of children</p>
        <h4 class="med-name">{{ printPackLabel?.prescriptionId }}</h4>
        <p class="dose-instruction">{{ printPackLabel?.patientName }}</p>
        <p class="dose-instruction">{{ printPackLabel?.pharmacyId }}</p>
      </div>

      <!-- <div class="barcode-section">
        <ngx-barcode6 [bc-value]="printPackLabel?.prescriptionId ?? ''" [bc-display-value]="false" [bc-width]="1"
          [bc-height]="20">
        </ngx-barcode6>
      </div> -->
    </div>
  </div>
</div>
<!-- medicine modal -->
<div id="medicine-modal">

</div>